// extracted by mini-css-extract-plugin
module.exports = {"categoryItem":"CategoryItem_categoryItem__1oi27","isSelected":"CategoryItem_isSelected__3keln","inner":"CategoryItem_inner__1J5gM"};